import { render, staticRenderFns } from "./FoodCategory.vue?vue&type=template&id=4bf643b5&scoped=true&"
import script from "./FoodCategory.vue?vue&type=script&lang=js&"
export * from "./FoodCategory.vue?vue&type=script&lang=js&"
import style0 from "./FoodCategory.vue?vue&type=style&index=0&id=4bf643b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf643b5",
  null
  
)

export default component.exports